import React from 'react';
import img1 from '../../../../print/Picture1.png';
import img2 from '../../../../print/Picture2.png';
import './Printing.css';

const Printing = () => {
    return (
        <section className='print-section'>
            <div className='print-header'></div>
            <div className='grid grid-cols-1 lg:grid-cols-2 gap-4 m-8'>
                <img src={img1} className='w-[580px]' alt="" />
                <img src={img2} alt="" />
            </div>
        </section>
    );
};

export default Printing;